// extracted by mini-css-extract-plugin
var _1 = "Presence-module__animateUploadProgressBarWidth--zn27S";
var _2 = "Presence-module__animatedBackground--LzK22";
var _3 = "Presence-module__avatar--DA7We";
var _4 = "Presence-module__counter--Wg4ay";
var _5 = "Presence-module__presence--NidIz";
var _6 = "Presence-module__presenceCompact--mm6jf";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "avatar", _4 as "counter", _5 as "presence", _6 as "presenceCompact" }
